import {Alert} from 'platform/components';
import {Box, Show} from 'platform/foundation';

import {isNotEmpty} from 'ramda';

import {useGetSupportedPlatformsQuery} from '@dms/api/core';
import {useGetPlatformsQuery} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {isAdvertisementPlatformEnabled} from '@dms/shared';

export function UnsuportedPlatformsNotification() {
  const {data: supportedPlatforms} = useGetSupportedPlatformsQuery();
  const {data: platforms = []} = useGetPlatformsQuery({});

  const unsuportedPlatforms = platforms
    .filter(isAdvertisementPlatformEnabled)
    .reduce((memo: string[], platform) => {
      if (supportedPlatforms?.codes && !supportedPlatforms.codes.includes(platform.code)) {
        memo.push(platform.title);
      }
      return memo;
    }, [])
    .toString();

  return (
    <Show when={isNotEmpty(unsuportedPlatforms)}>
      <Box paddingBottom={4}>
        <Alert
          type="inline"
          variant="info"
          title={`${i18n.t('entity.promoPhotos.notifications.unsuportedPlatforms')}:`}
          message={unsuportedPlatforms}
        />
      </Box>
    </Show>
  );
}
